// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS208: Avoid top-level this
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
class FeedbackService {
   $feedbackTypes: any
   $feedbackUserRoles: any
   $http: any
   $location: any
   recaptcha: any
   scope: any
   constructor($http: any, $location: any, $feedbackTypes: any, $feedbackUserRoles: any, recaptcha: any) {
      this.resetScope = this.resetScope.bind(this)
      this.send = this.send.bind(this)
      this.$http = $http
      this.$location = $location
      this.$feedbackTypes = $feedbackTypes
      this.$feedbackUserRoles = $feedbackUserRoles
      this.recaptcha = recaptcha
      this.resetScope()
   }

   resetScope() {
      return this.scope = {
         feedback_type: this.$feedbackTypes[1],
         role: this.$feedbackUserRoles[1],
         feedback_text: '',
         email: '',
         satisfaction_level: ''
      }
   }

   send() {
      this.scope.referrer = this.$location.absUrl()

      return this.recaptcha.execute("feedback_submit")

         .then((token: string) => {

            if (!token) {
            throw new Error("no_token")
            }

            const data = _.extend({}, this.scope, {
            captchaValidation: token
            })

            return this.$http.post("/feedback/submit", data)
         })

         .then((response: any) => {
            return response.data
         })

         .catch((err: any) => {
            console.error("Feedback send failed:", err)
            throw err
         })
   }

   feedbackTypes() {
      return this.$feedbackTypes
   }
   userRoles() {
      return this.$feedbackUserRoles
   }
}

FeedbackService.$inject = ['$http', '$location', '$feedbackTypes', '$feedbackUserRoles',
   'recaptchaService']

angular.module('summonApp.services')
   .service('feedbackService', FeedbackService)
